import ApplicationShell from 'Application/ApplicationShell';
import React from 'react';
import SessionManagementProvider from 'Application/SessionManagementProvider';
import MainNav from 'Application/MainNav';
import PageContent from './PageContent';
import Footer from './Footer';
import Header from './Header';

export default function XMattersApp() {
  return (
    <SessionManagementProvider>
      <ApplicationShell
        header={<Header />}
        footer={<Footer />}
        content={<PageContent />}
        nav={<MainNav />}
      />
    </SessionManagementProvider>
  );
}

XMattersApp.displayName = 'XMattersApp';
